var path = 'src/app/forms/group.html';
var html = "<div class=form-group ng-class=\"{'required': isRequired()}\" frm-status ng-transclude></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/group.html
 ** module id = 328
 ** module chunks = 0
 **/